<p>license-history works!</p>
